import { Box, FormLabel, forwardRef, Select, SelectProps } from '@chakra-ui/react'

interface ISelectInputProps extends SelectProps {
  isDisabled?: boolean
}

const SelectInput = forwardRef((props: ISelectInputProps, ref) => {
  const { isDisabled = false, ...rest } = props

  return <Select rounded='md' color='#666666' borderRadius='0' ref={ref} {...rest}></Select>
})

export { SelectInput }
